import { logout } from '../en';

export const logoutAR: typeof logout = {
  title: 'لقد تم تسجيل خروجك بنجاح من XYZ.',
  text: `نشكرك على إلقاء نظرة على بصمتك الكربونية. معًا ، نحن قوة مالية للتغيير.`,
  button: 'رجوع إلى Mashreq',
  url: 'https://www.mashreqbank.com/en/uae/personal/',
};
